module.exports = __webpack_public_path__ + "img/Mediaprotection2.09080664.png";